<script setup lang="ts">
/**
 * Simple overlay component for blocking content.
 * Unlike BaseModal, this doesn't teleport to body, handle escape/click dismissal,
 * or lock body scroll. It's meant for non-dismissible overlays like orientation warnings.
 */
withDefaults(defineProps<{
  /** Background color/opacity */
  background?: string;
  /** Z-index for stacking */
  zIndex?: number;
}>(), {
  background: 'rgba(0, 0, 0, 0.85)',
  zIndex: 100
});
</script>

<template>
  <div
    class="base-overlay"
    :style="{
      backgroundColor: background,
      zIndex: zIndex
    }"
  >
    <div class="base-overlay__content">
      <slot />
    </div>
  </div>
</template>

<style scoped>
.base-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.base-overlay__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-md);
  padding: var(--spacing-lg);
  text-align: center;
}
</style>
